<template>
    <el-card style="width: 250px; height: 350px; min-width: 250px;" body-style="padding:0px">
        <router-link :to="{ name: 'details', query: { img_id: imageInfo.picture_id } }">
            <el-image style="width: 100%; height: 280px" :src="imageInfo.regular_url" fit="cover" lazy>
                <template #error>
                    <div class="image-slot">
                        <el-icon><icon-picture /></el-icon>
                    </div>
                </template>
            </el-image>
        </router-link>

        <template #footer>
            <div class="title">{{ imageInfo.title }}</div>
            <div class="user" style="display: flex;"><el-icon>
                    <Star />
                </el-icon>{{ imageInfo.like_total }}</div>
        </template>
    </el-card>
</template>

<style scoped>
.title,
.user {
    text-align: left;
}

.title {
    font-size: 1rem;
    margin-bottom: 10px;
}

.user {
    font-size: .8rem;
    color: rgb(169, 173, 173);
}

.title:hover {
    color: brown;
}

/* .el-image {
    opacity: 0;
    animation: mymove 0.6s ease-in forwards;
} */

.el-image:hover {
    transform: scale(1.5);
    transition: .15s;
}

.image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: var(--el-fill-color-light);
    color: var(--el-text-color-secondary);
    font-size: 35px;
}


/* @keyframes mymove {
    10% {
        opacity: 0.1;
    }

    50% {
        opacity: 0.5;
    }

    60% {
        opacity: 0.6;
    }

    90% {
        opacity: 0.9;
    }

    100% {
        opacity: 1;
    }
} */
</style>

<script>
import { Picture as IconPicture } from '@element-plus/icons-vue'

export default {
    props: {
        imageInfo: {
            type: Object,
            default() {
                return {
                    "picture_id": "",
                    "title": "",
                    "width": 2438,
                    "height": 4093,
                    "regular_url": "",
                    "original_url": "",
                    "page_total": 1,
                    "status": 5,
                    "type": 0,
                    "like_total": 0,
                    "comment_total": 0,
                    "tags": "",
                    "created_at": ""
                }
            }
        },
        index: {
            default: 1,
        }
    },

    components: {
        IconPicture
    }
}
</script>
